import { ref } from "vue-demi";
import { reqSelectRegionById } from "../request/ucenterapi/internal/region/selectRegionById/get.js";
const regionNameMap = new Map();
function getRegionNameByCode(code) {
  if (!code)
    return "";
  const cached = regionNameMap.get(code);
  if (cached)
    return cached.value;
  const nameRef = ref("");
  regionNameMap.set(code, nameRef);
  reqSelectRegionById(code).then((region) => {
    if (region == null ? void 0 : region.pidsName) {
      nameRef.value = region.pidsName;
    }
  });
  return nameRef.value;
}
export { getRegionNameByCode };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getRegionNameByCode.js